//src/Components/EmojiPicker/PreviewEmojiContext.tsx
import { useCallback, createContext, useRef, ReactNode } from 'react';

import { EmojiData, IEmojiPreviewRef } from '.';
import { PreviewEmojiContext } from './contexts';

export default function PreviewEmojiContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const emojiPreviewRef = useRef<IEmojiPreviewRef>(null);

  const setPreview = useCallback((emoji?: EmojiData) => {
    emojiPreviewRef.current?.setPreview(emoji);
  }, []);

  return (
    <PreviewEmojiContext.Provider value={{ emojiPreviewRef, setPreview }}>
      {children}
    </PreviewEmojiContext.Provider>
  );
}
